import { createGlobalStyle } from 'styled-components';
/**
 * pointer-events: none and cursor won't work together
 * since pointer-events will disable all mouse events which will prevent cursor style
 */
export const disabledStyles = createGlobalStyle`
  *[data-preview-disable="true"],
  *[contenteditable="true"],
  button:not(.ant-drawer-close):not(.ant-modal-close),
  input,
  textarea,
  select,
  label,
  .ozone-select-container,
  .ant-dropdown-trigger,
  .ant-upload-select,
  .ant-upload-drag,
  .ant-slider,
  .ant-picker,
  .ant-input-number,
  .ag-center-cols-container .ag-row,
  .status-indicator.task-field-value,
  *[class*='rich-text-editor'],
  *[class*='overview'] a {
    pointer-events: none !important;
  }

  *[data-preview-enable="true"] button,
  *[data-preview-enable="true"] input,
  *[data-preview-enable="true"] textarea,
  *[data-preview-enable="true"] select,
  *[data-preview-enable="true"] label,
  .ant-dropdown-trigger.more-responsible-filters {
    pointer-events: inherit !important;
  }

  *[data-preview-hide] {
    display: none !important;
  }
`;
